import { FC, useState } from 'react'
import { PaymentElement } from '@stripe/react-stripe-js'
import { StripePaymentElementChangeEvent } from '@stripe/stripe-js'
import { displayPaymentMethodAddressFields } from '@dtx-company/app/shared/common/src/components/PlanPurchaseExperience/constants'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'

export interface CreatePaymentMethodProps {
  onChange: (event: StripePaymentElementChangeEvent) => void
  heapEventName?: string
  onFocus?: () => void
}

export const CreatePaymentMethod: FC<CreatePaymentMethodProps> = ({
  onChange,
  heapEventName,
  onFocus
}) => {
  // The onChange event fires on load, before the user changes anything
  // So defer heap tracking until the user actually makes a change
  const [trackHeap, setTrackHeap] = useState(false)
  const [type, setType] = useState('card')
  const handleChangeCard = (event: StripePaymentElementChangeEvent): void => {
    setType(event.value.type)
    if (trackHeap) {
      fireAnalyticsEvent(heapEventName || 'Revenue_Upgrade_Changed_PaymentElementInfo', {
        complete: event.complete,
        empty: event.empty,
        paymentMethodType: event.value.type
      })
    }
    setTrackHeap(true)
    if (onChange) onChange(event)
  }

  return (
    <PaymentElement
      onFocus={onFocus}
      onChange={e => handleChangeCard(e)}
      options={{
        fields: {
          billingDetails: {
            name: displayPaymentMethodAddressFields.includes(type) ? 'never' : 'auto'
          }
        }
      }}
    />
  )
}
